import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/lock-blue-grey-lighten-2.svg'
import _imports_1 from '@/assets/img/icon/danger-red.png'
import _imports_2 from '@/assets/img/icon/scan-orange.svg'


const _hoisted_1 = { id: "delivery-pending-detail" }
const _hoisted_2 = { class: "background-grey-lighten-5 px-6 py-6 mb-4 rounded-lg" }
const _hoisted_3 = { class: "sm:flex w-full items-center justify-between" }
const _hoisted_4 = { class: "font-bold py-2 text-2xl md:text-3xl" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "w-10 hidden sm:block"
}
const _hoisted_6 = { class: "flex items-center mb-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "font-normal color-blue-grey-darken-1 text-sm md:text-base" }, "Berangkat : ", -1)
const _hoisted_8 = { class: "color-green-darken-1 text-sm md:text-base" }
const _hoisted_9 = { class: "md:flex items-center justify-between" }
const _hoisted_10 = { class: "md:flex items-center" }
const _hoisted_11 = { class: "flex items-center md:mt-0 batas-chip mr-3 pr-3" }
const _hoisted_12 = {
  class: "rounded-md background-green-lighten-5 py-1 px-3 mr-2",
  style: {"border":"1px solid #66BB6A"}
}
const _hoisted_13 = { class: "color-green-darken-1 text-base" }
const _hoisted_14 = {
  class: "rounded-md background-grey-lighten-5 py-1 px-3",
  style: {"border":"1px solid #607D8B"}
}
const _hoisted_15 = { class: "color-blue-grey text-base" }
const _hoisted_16 = { class: "flex items-center gap-2 mt-3 md:mt-0" }
const _hoisted_17 = { class: "color-blue-grey text-base font-bold" }
const _hoisted_18 = {
  key: 0,
  class: "pi pi-check w-4 h-4 font-semibold",
  style: {"color":"#4CAF50"}
}
const _hoisted_19 = {
  key: 1,
  src: _imports_1,
  class: "w-5"
}
const _hoisted_20 = { class: "md:mt-0 mt-3" }
const _hoisted_21 = {
  key: 0,
  class: "color-red font-semibold text-base md:text-lg"
}
const _hoisted_22 = {
  key: 1,
  class: "flex gap-1 items-center"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold text-base" }, "Penutup: ", -1)
const _hoisted_24 = { class: "text-black font-bold text-base" }
const _hoisted_25 = { class: "flex w-full container-input-check-resi mb-5" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "icon-scan-input w-10"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "flex rounded-full background-green p-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-check text-white w-4 h-4 text-bold" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-black" }, "Sudah Diproses", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-black" }, "Tutup Jadwal", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_TableReceiptCheckingDetail = _resolveComponent("TableReceiptCheckingDetail")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogDetailResi = _resolveComponent("DialogDetailResi")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("p", _hoisted_4, _toDisplayString(_ctx.dataHeader.KodeJadwal), 1),
            (_ctx.dataHeader.IsClose)
              ? (_openBlock(), _createBlock("img", _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.moment(_ctx.dataHeader.TanggalAktif).format('dddd, DD MMMM YYYY')), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("p", _hoisted_13, "RIT " + _toDisplayString(_ctx.dataHeader.Rit), 1)
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("p", _hoisted_15, _toDisplayString(_ctx.dataHeader.Kode), 1)
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("span", _hoisted_17, "Sudah Dicek : " + _toDisplayString(_ctx.dataHeader.DoneScan) + "/" + _toDisplayString(_ctx.dataHeader.NotDoneScan+_ctx.dataHeader.DoneScan), 1),
                (_ctx.dataHeader.DoneScan === _ctx.dataHeader.NotDoneScan+_ctx.dataHeader.DoneScan)
                  ? (_openBlock(), _createBlock("i", _hoisted_18))
                  : (_openBlock(), _createBlock("img", _hoisted_19))
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              (!_ctx.dataHeader.IsClose)
                ? (_openBlock(), _createBlock("p", _hoisted_21, "Belum Ditutup"))
                : (_openBlock(), _createBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode("p", _hoisted_24, _toDisplayString(`${_ctx.dataHeader.NamaLengkap} (${_ctx.moment(_ctx.dataHeader.CloseDate).format('DD MMMM YYYY')})`), 1)
                  ]))
            ])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_InputText, {
                placeholder: "Scan barcode untuk melakukan pengecekan resi",
                class: "input-pengecekan-resi input-primary w-full",
                ref: "refInputScanResi",
                modelValue: _ctx.inputScanResi,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputScanResi = $event)),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchResi(_ctx.inputScanResi)), ["enter"]))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode("div", null, [
            (_ctx.showTableDetail)
              ? (_openBlock(), _createBlock(_component_TableReceiptCheckingDetail, {
                  key: 0,
                  jadwalId: Number(_ctx.decryptData()),
                  dataHeader: _ctx.dataHeader,
                  onReloadHeader: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getHeader())),
                  onShowDetailResi: _ctx.showDetailResi,
                  ref: "refTableReceiptCheckingDetail"
                }, null, 8, ["jadwalId", "dataHeader", "onShowDetailResi"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.dataHeader.IsClose)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "btn-secondary p-button-sm flex gap-2 cursor-default"
            }, {
              default: _withCtx(() => [
                _hoisted_27,
                _hoisted_28
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "btn-primary p-button-sm flex gap-2 cursor-pointer",
              onClick: _ctx.submitData
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }, 8, ["onClick"]))
      ]),
      _: 1
    }),
    (_ctx.showDialogDetail)
      ? (_openBlock(), _createBlock(_component_DialogDetailResi, {
          key: 0,
          isRefund: false,
          idTrans: _ctx.idDetail,
          isShowDialog: _ctx.showDialogDetail,
          onHideDialog: _ctx.hideDialogDetail,
          onReloadData: _ctx.reloadFromDialog,
          idJadwal: Number(_ctx.decryptData())
        }, null, 8, ["idTrans", "isShowDialog", "onHideDialog", "onReloadData", "idJadwal"]))
      : _createCommentVNode("", true)
  ]))
}